import FormControlLabel, {
  type FormControlLabelProps,
} from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import {
  type Control,
  Controller,
  type FieldPath,
  type FieldValues,
} from "react-hook-form";

export type ReactHookSwitchProps<
  T extends FieldValues = FieldValues,
  C = any,
> = Omit<Partial<FormControlLabelProps>, "control" | "defaultValue"> & {
  name: FieldPath<T>;
  label: string;
  control?: Control<T, C>;
};

export function ReactHookSwitch<T extends FieldValues = FieldValues, C = any>({
  name,
  label,
  control,
  sx,
  labelPlacement = "start",
  ...props
}: ReactHookSwitchProps<T, C>) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <FormControlLabel
          label={label}
          labelPlacement={labelPlacement}
          {...props}
          sx={{ m: 0, ...sx }}
          control={<Switch {...field} checked={field.value} />}
        />
      )}
    />
  );
}
